(function () {
  const SELECTOR = {
    section: '.js-carousel',
    imageSlide: '.js-about__carousel .swiper-slide',
    trigger: '.js-about-lightbox-trigger',
    lightbox: '.js-about-lightbox',
  };

  function collectItems(root) {
    const items = [];
    root.querySelectorAll(SELECTOR.trigger).forEach(function (trigger, index) {
      const img = trigger.querySelector('img');
      items.push({
        index: index,
        src: trigger.getAttribute('data-full-src') || (img && (img.currentSrc || img.src)) || '',
        alt: (img && img.alt) || '',
        caption: trigger.getAttribute('data-caption') || '',
        el: trigger,
      });
    });
    return items;
  }

  function pauseSwiper(root) {
    const swiperEl = root.querySelector('.js-about__carousel');
    const swiper = swiperEl && swiperEl.swiper;
    if (swiper && swiper.autoplay) {
      swiper.autoplay.stop();
      return swiper;
    }
    return null;
  }

  function resumeSwiper(swiper) {
    if (swiper && swiper.autoplay && typeof swiper.autoplay.start === 'function') {
      swiper.autoplay.start();
    }
  }

  function bindLightbox(box) {
    if (!box || box.dataset.bound === 'true') return;
    box.dataset.bound = 'true';

    const state = {
      items: [],
      index: 0,
      swiper: null,
      lastFocus: null,
    };

    const imgEl = box.querySelector('.about-lightbox__img');
    const capEl = box.querySelector('.about-lightbox__caption');
    const dialog = box.querySelector('.about-lightbox__dialog');

    function render() {
      const item = state.items[state.index];
      if (!item || !imgEl) return;
      imgEl.src = item.src;
      imgEl.alt = item.alt;
      if (capEl) {
        if (item.caption) {
          capEl.hidden = false;
          capEl.textContent = item.caption;
        } else {
          capEl.hidden = true;
          capEl.textContent = '';
        }
      }
      box.classList.toggle('is-single', state.items.length < 2);
    }

    function open(items, index, swiper) {
      state.items = items;
      state.index = index;
      state.swiper = swiper || null;
      state.lastFocus = document.activeElement;
      render();
      box.removeAttribute('hidden');
      requestAnimationFrame(function () {
        box.classList.add('is-open');
      });
      document.body.classList.add('about-lightbox-open');
      if (dialog) dialog.focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.body.classList.remove('about-lightbox-open');
      resumeSwiper(state.swiper);
      window.setTimeout(function () {
        if (!box.classList.contains('is-open')) {
          box.setAttribute('hidden', '');
          if (imgEl) imgEl.removeAttribute('src');
        }
      }, 280);
      if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
        state.lastFocus.focus();
      }
    }

    function step(delta) {
      if (state.items.length < 2) return;
      state.index = (state.index + delta + state.items.length) % state.items.length;
      render();
    }

    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-lightbox-close]')) close();
      if (e.target.closest('[data-lightbox-prev]')) step(-1);
      if (e.target.closest('[data-lightbox-next]')) step(1);
    });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });

    var touchX = null;
    box.addEventListener(
      'touchstart',
      function (e) {
        if (!box.classList.contains('is-open')) return;
        touchX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );
    box.addEventListener(
      'touchend',
      function (e) {
        if (touchX == null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 50) step(dx > 0 ? -1 : 1);
      },
      { passive: true }
    );

    box._open = open;
    box._close = close;
  }

  function findLightbox(root) {
    var host = root.closest('.shopify-section') || root.parentElement;
    if (host) {
      var local = host.querySelector(SELECTOR.lightbox);
      if (local) return local;
    }
    return document.querySelector(SELECTOR.lightbox);
  }

  function initSection(root) {
    if (!root || root.dataset.lightboxReady === 'true') return;
    var box = findLightbox(root);
    if (!box) return;
    root.dataset.lightboxReady = 'true';
    bindLightbox(box);

    root.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest(SELECTOR.trigger);
        if (!trigger || !root.contains(trigger)) return;
        e.preventDefault();
        e.stopPropagation();
        var items = collectItems(root);
        var idx = items.findIndex(function (item) {
          return item.el === trigger;
        });
        if (idx < 0) idx = 0;
        box._open(items, idx, pauseSwiper(root));
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll(SELECTOR.section).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section =
      e.target.querySelector(SELECTOR.section) || e.target.closest(SELECTOR.section);
    if (section) initSection(section);
  });
})();